import { EventTypes } from 'redux-segment';

import H from 'constants/httpMethod.const';
import QST from 'constants/quickSetupType.const';
import { AUTH_API } from 'middleware/api';
import authenticatedEndpoint from 'utils/backend/authenticatedEndpoint.util';
import jsonEndpoint from 'utils/backend/jsonEndpoint.util';
import withOptions from 'utils/functions/withOptions.util';
import logger from 'utils/logger.util';

import { QUICK_SETUP_FAILURE, QUICK_SETUP_REQUEST, QUICK_SETUP_SUCCESS } from './postQuickSalonData.types';

const ATAG = 'postQuickSalonData';
const L = logger(ATAG);

const postQuickSalonData = L.wrap(
  '()',
  withOptions(({ data, type }) => ({
    ATAG,
    [AUTH_API]: {
      ...authenticatedEndpoint({ pinSafe: true }),
      ...jsonEndpoint(H.post, 'salon/setup/', data),
      types: [QUICK_SETUP_REQUEST, QUICK_SETUP_SUCCESS, QUICK_SETUP_FAILURE],
    },
    meta: {
      analytics: {
        eventType: EventTypes.track,
        eventPayload: { event: 'quickSetup', properties: { type: type || QST.hair } },
      },
    },
  })),
);

// noinspection JSUnusedGlobalSymbols
export default postQuickSalonData;
